import React, { PureComponent } from 'react';
import styled from 'styled-components';

const Button = styled.button`
width: auto;
height: auto;
color: ${(props) => props.color || "#000000"};
font-weight: bold;
font-size: 15px;
`
const ButtonOuter = styled.div`
display: flex;
align-items: center;
justify-content: center;
height: ${(props) => props.height || "100%"};
width: ${(props) => props.width || "100%"};
padding:${(props) => props.padding || "0"};
margin:${(props) => props.margin || "0"};
border-radius:${(props) => props.borderRadius || "5px"};
background: ${(props) => props.background || "#ffffff"};
border: ${(props) => props.border || "none"};
&:hover{ opacity: 0.7;};
cursor: pointer;
`
class ButtonAtom extends PureComponent {

    render() {
        return (
          <ButtonOuter
            width={this.props.width}
            height={this.props.height}
            margin={this.props.margin}
            background={this.props.background}
            border={this.props.border}
            onClick={this.props.onClick}
          >
            <Button typo={this.props.typo} color={this.props.color}>
              {this.props.text}
            </Button>
          </ButtonOuter>
        );
    }
}

export default ButtonAtom;